module.exports = __webpack_public_path__ + "img/9E7C7E_DDCBD0_351D20_683B38-256px.5a5b085a.png";